import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Asset } from '../../../../model/asset';
import { MapService } from '../../../../services/map.service';
import { AssetsService } from '../../../../services/assets.service';
import { AssetProperty } from '../../../../model/asset-property';
import * as mapboxgl from 'mapbox-gl';
import { translate } from '@ngneat/transloco';

@Component({
  selector: 'app-asset-overview',
  templateUrl: './asset-overview.component.html',
  styleUrls: ['./asset-overview.component.scss']
})
export class AssetOverviewComponent implements OnInit, OnDestroy {

  public readonly DEFAULT_ZOOM = 14;

  @Input()
  public asset: Asset;

  public properties: AssetProperty[];

  public activeDataCategories: string[];
  public activeData: any[];

  public marker;
  public map: mapboxgl.Map;

  public noMeasurements: boolean;
  public loadingMeasurements: boolean;
  public loadedMap: boolean;

  constructor(private mapService: MapService,
              private assetsService: AssetsService) {
    this.activeDataCategories = [translate('model.asset'), translate('model.devices')];
    this.activeData = [
      {name: translate('misc.overview.total'), data: null, color: '#DDDDDD' },
      {name: translate('misc.overview.withData'), data: null, color: '#3C97DA'},
      {name: translate('misc.overview.withDataToday'), data: null, color: '#8eda3c'}
    ];
  }

  ngOnInit(): void {
    this.buildAndConfigureMap();
    this.loadAssetProperties();
    this.loadActiveMeasurementsData();
  }

  private loadAssetProperties(): void {
    this.assetsService.getAssetProperties(this.asset.uuid).subscribe(response => {
      this.properties = response.assetProperties;
    });
  }

  private loadActiveMeasurementsData(): void {
    this.loadingMeasurements = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const assetsPromise = this.assetsService.getAssetActiveAssetMeasurements(this.asset.uuid, today.getTime())
      .toPromise().finally(() => this.loadingMeasurements = false);
    const devicesPromise = this.assetsService.getAssetActiveDeviceMeasurements(this.asset.uuid, today.getTime())
      .toPromise().finally(() => this.loadingMeasurements = false);
    Promise.all([assetsPromise, devicesPromise]).then(values => {
      if (values[0].countResult.total === 0 && values[1].countResult.total === 0) {
        this.noMeasurements = true;
        return;
      }
      const assetResult = values[0].countResult;
      const devicesResult = values[1].countResult;
      this.activeData[0].data = [+assetResult.total, +devicesResult.total];
      this.activeData[1].data = [+assetResult.withData, +devicesResult.withData];
      this.activeData[2].data = [+assetResult.withDataFrom, +devicesResult.withDataFrom];
      const activeData = this.activeData;
      this.activeData = undefined;
      setTimeout(() => this.activeData = activeData, 0);
    });
  }

  private buildAndConfigureMap(): void {
    this.loadedMap = false;
    const latitude = this.asset.latitude;
    const longitude = this.asset.longitude;
    this.map = this.mapService.buildMap(this.DEFAULT_ZOOM, latitude, longitude);
    this.mapService.buildStaticPulsingDot(this.map, latitude, longitude);
    this.loadedMap = true;
  }

  ngOnDestroy(): void {
    this.map.remove();
  }

}
